module.exports = __webpack_public_path__ + "img/Weapon_233.5befe502.png";